"use client";

import { SWRConfig } from "swr";

/**
 * @typedef {object} Props
 * @prop {import("swr").SWRConfiguration} value
 * @prop {React.ReactNode} children
 */
/**
 * @param {Props} props
 */
export function SWRConfigProvider({ children, value }) {
  return <SWRConfig value={value}>{children}</SWRConfig>;
}
